import UUID from "../uuid";
import isFeatureToggleOn from "../utils/feature_toggle"
import AdSkipButton from '../advertisements/ad_skip_button';

export default class InstreamAdvertisement {
  constructor({ tech, params, ima, data } = {}) {
    this._tech = tech;
    this._params = params;
    this._ima = ima;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  params() {
    return this._params;
  }

  ima() {
    return this._ima;
  }

  data() {
    return this._data;
  }

  adPlaylistId() {
    return this._adPlaylistId;
  }

  currentAdType() {
    return this._currentAdType;
  }

  adSkipButton() {
    return this._adSkipButton;
  }

  init() {
    if (this.params().prerollTag()) {
      this.setup();
    }
  }

  setup() {
    this._currentAdType = "pre";

    if (this.params().adTagIsVmap()) {
      this._adPlaylistId = UUID.v4();
    } else {
      this._adPlaylistId = null;
    }

    this.bindRequestAdsPlay();
    this.setupAdSkipButton();
  }

  setupAdSkipButton() {
    this._adSkipButton = new AdSkipButton({ tech: this.tech(), ima: this.ima(), data: this.data() });
    this.adSkipButton().init();
  }

  bindRequestAdsPlay() {
    try {
      this.setupIma();
    } catch (e) {
      const imaAdContainer = document.querySelector('#ima-ad-container');
      if (imaAdContainer) {
        imaAdContainer.remove();
      }
    }
  }

  setupIma() {
    if (!this.ima().imaAlreadySetup()) {
      this.ima().setup(this.tech().id(), this.params().prerollTag());
    }
  }
}